<template>
  <div 
    v-if="!isMobile"
    class="sm-actions-table sm-list__actions"
  >
    <btn-block
      v-for="item in groupActions"
      :key="item.name"
      :classes="['sm-txt-capitalize']"
      :type="'action'"
      :text="item.text"
      :icon="item.icon"
      @click="$emit('triggerGroupAction', item.name)"
      :class="{
        'disabled': item.disabled
      }"
    />
  </div>
  <div
    v-else
    class="sm-mobile-actions-table"
  >
    <a
      href="#"
      class="sm-mobile-actions-table__back"
      @click.prevent="back"
    >
      <span></span>
    </a>
    <span class="sm-mobile-actions-table__selected">{{selected}}</span>
    <button
      v-for="item in groupActions"
      :key="item.name"
      class="sm-mobile-actions-table__action"
      @click="$emit('triggerGroupAction', item.name)"
    >
      <include-svg :name="item.icon" />
    </button>
    <!-- <btn-block
      v-for="item in groupActions"
      :key="item.name"
      :classes="['sm-txt-capitalize']"
      :type="'action'"
      :text="item.text"
      :icon="item.icon"
      @click="$emit('triggerGroupAction', item.name)"
    /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'group-actions',
  props: {
    groupActions: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  methods: {
    back() {
      this.$emit('remove-selection', true);
    }
  },
}
</script>